export const CHART_COLORS  = [
    '#636efa',   
    '#00fc79',
    '#fff81f',
    '#6addff',
    '#9b59b6',
    '#f1c40f',
    '#2ecc71',
    '#e74c3c',
    '#8e44ad',
    '#d35400'
  ];



// WEBPACK FOOTER //
// ./src/providers/trend-live-services/chartColors.ts